import { CaretUpIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowUpSmall = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <CaretUpIcon size={Sizes[size]} {...rest} color={stroke || fill} />;
};

ArrowUpSmall.displayName = 'ArrowUpSmall';
